import { userApi } from "./http";

export async function fetchChatMessages(caseId) {
  const { data } = await userApi.get(`/chat/${encodeURIComponent(caseId)}/messages`);
  return Array.isArray(data) ? data : [];
}

export async function fetchPublicKey(userId) {
  const { data } = await userApi.get(`/users/${encodeURIComponent(userId)}/public-key`);
  return data;
}

export async function upsertOwnPublicKey(publicKey) {
  const { data } = await userApi.put("/users/me/public-key", { publicKey });
  return data;
}
export async function uploadDocument(caseId, file, payload) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("encryptedMessage", payload.encryptedMessage || "");
  formData.append("iv", payload.iv || "");
  formData.append("encryptedSessionKey", payload.encryptedSessionKey || "");
  formData.append("senderEncryptedSessionKey", payload.senderEncryptedSessionKey || "");
  formData.append("fileIv", payload.fileIv || "");
  formData.append("originalMimeType", payload.originalMimeType || "");
  
  const { data } = await userApi.post(`/chat/${encodeURIComponent(caseId)}/upload`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return data;
}
